import { Box, MenuItem, Select, TextField, Typography } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import * as Constant from 'common/Constant';
import moment from 'moment-timezone';
import React from 'react';

const PCell = ({
  rowData,
  field,
  showEdit,
  isEdited,
  onCellClick,
  onChange,
  editorType,
  options,
  minDate,
  maxDate,
  duplicateError
}) => {
  const renderCell = () => {
    if (!showEdit) {
      const style = { color: 'black', fontWeight: 'normal' };
      if (isEdited) {
        style.color = 'green';
        style.fontWeight = 'bold';
      }
      if (duplicateError) {
        style.color = 'red';
        style.fontWeight = 'normal';
      }
      let value = rowData[field];
      if (editorType === 'date' && !value) {
        style.color = '#d3d3d3';
        style.fontWeight = 'normal';
        value = 'MM/DD/YYYY';
      }
      return <Typography style={style}>{value}</Typography>;
    }
    switch (editorType) {
      case 'date':
        return (
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
              minDate={minDate ? moment.utc(minDate) : undefined}
              maxDate={maxDate ? moment.utc(maxDate) : undefined}
              inputFormat={Constant.FORMAT_DATE}
              value={rowData[field] ? moment.utc(rowData[field]) : null}
              onChange={(date) => {
                return date ? onChange(rowData.id, field, moment.utc(date).format(Constant.FORMAT_DATE)) : null;
              }}
              renderInput={(params) => <TextField fullWidth {...params} />}
            />
          </LocalizationProvider>
        );
      case 'dropdown':
        return (
          <Select
            fullWidth
            value={rowData[field]}
            labelId="label-application"
            id="input-application"
            onChange={(event) => {
              onChange(rowData.id, field, event.target.value);
            }}>
            {options.map((item) => {
              return (
                <MenuItem key={'key-' + item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              );
            })}
          </Select>
        );
      case 'number':
        return (
          <TextField
            type="number"
            defaultValue={rowData[field]}
            onChange={(event) => {
              onChange(rowData.id, field, event.target.value);
            }}
          />
        );
      default:
        return (
          <TextField
            defaultValue={rowData[field]}
            onChange={(event) => {
              onChange(rowData.id, field, event.target.value);
            }}
          />
        );
    }
  };
  return (
    <Box
      style={{
        width: '100%',
        height: '100%',
        paddingTop: showEdit ? '0px' : '10px',
        paddingBottom: showEdit ? '0px' : '10px'
      }}
      onClick={() => {
        onCellClick(rowData.id, field);
      }}>
      {renderCell()}
    </Box>
  );
};
export const PlanExpenseCell = React.memo(PCell);
